import { render, staticRenderFns } from "./CalendarioHistorico.vue?vue&type=template&id=774009b0&scoped=true&"
import script from "./CalendarioHistorico.vue?vue&type=script&lang=ts&"
export * from "./CalendarioHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarioHistorico.vue?vue&type=style&index=0&id=774009b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774009b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('774009b0', component.options)
    } else {
      api.reload('774009b0', component.options)
    }
    module.hot.accept("./CalendarioHistorico.vue?vue&type=template&id=774009b0&scoped=true&", function () {
      api.rerender('774009b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/CalendarioHistorico/CalendarioHistorico.vue"
export default component.exports